export const ar = {
  home: 'الرئيسية',
  dashboard: 'لوحة المعلومات',
  judicialTableegh: 'التبليغ العدلي',
  eServices: 'الخدمات الإلكترونية',
  retreat: 'تراجع',
  delete: 'حذف',
  cancel: 'إلغاء',
  next: 'التالي',
  previous: 'السابق',
  rejectRequest: 'إلغاء الطلب',
  useTheService: 'استخدم الخدمة',
  cancelRequestConfirmation: 'هل انت متأكد من إلغاء الطلب؟',
  cancelRequestConfirmationText: 'بتأكيد الإلغاء لن يتم حفظ البيانات التي ادخلتها',
  unAvailable: 'غير متوفر',
  edit: 'تعديل',
  verificationServices: 'خدمات التحقق',
  hijriSuffix: 'هـ',
  gregorianSuffix: 'م',
  morningTimeFullSuffix: 'صباحاً',
  eveningTimeFullSuffix: 'مساءاً',

  serverErrors: {
    NOT_FOUND: 'لا يمكننا خدمتك في الوقت الحالي. الرجاء المحاولة لاحقاً',
    SERVER_ERROR: 'حدث خطأ في النظام الرجاء المحاولة لاحقاً',
    BIRTH_DATE_AND_SOCIAL_ID: 'رقم الهوية أو تاريخ الميلاد غير صحيح',
    RequestShouldBeValidToCancel: 'حدث خطأ ما , طلب غير صالح',
  },

  validations: {
    onlyNumbers: 'الرجاء إدخال أرقام فقط',
    minNumbersLength: 'أقل عدد للأرقام هو {length} ',
    fieldIsRequired: 'هذا الحقل مطلوب',
    shouldContainNumbers: 'يجب أن يحتوي على {numbers} رقم',
    minNumberValue: 'برجاء إدخال رقم أكبر من {minValue}',
  },
};
